import { FiMoon, FiSun, FiSunrise, FiSunset } from "react-icons/fi";
import {
  ACCENT_800,
  WHEAT,
  PALE_PURPLE,
  PICTON_BLUE_200,
  MAGIC_MINT,
} from "../components/common/colors";

export const dayLabels = [
  { label: "SUN", value: "sunday" },
  { label: "MON", value: "monday" },
  { label: "TUE", value: "tuesday" },
  { label: "WED", value: "wednesday" },
  { label: "THU", value: "thursday" },
  { label: "FRI", value: "friday" },
  { label: "SAT", value: "saturday" },
];

export const sessionTypeOptions = [
  {
    id: "online",
    label: "ONLINE",
    value: "online_slots",
    slug: "provider_online_schedules",
    bgColor: WHEAT,
  },
  {
    id: "in-person",
    label: "IN-PERSON",
    value: "offline_slots",
    slug: "provider_offline_schedules",
    bgColor: PICTON_BLUE_200,
  },
  {
    id: "both",
    label: "BOTH",
    value: "both_slots",
    slug: "provider_both_schedules",
    bgColor: MAGIC_MINT,
  },
  {
    id: "on-site",
    label: "ON-SITE",
    value: "onsite_slots",
    slug: "provider_onsite_schedules",
    bgColor: PALE_PURPLE,
  },
];

export const sessionTypesForConsultants = [
  {
    id: "online",
    label: "ONLINE",
    value: "online_slots",
    slug: "provider_online_schedules",
    bgColor: WHEAT,
  },
  {
    id: "in-person",
    label: "IN-PERSON",
    value: "offline_slots",
    slug: "provider_offline_schedules",
    bgColor: PICTON_BLUE_200,
  },
  {
    id: "both",
    label: "BOTH",
    value: "both_slots",
    slug: "provider_both_schedules",
    bgColor: MAGIC_MINT,
  },
];

export const legendTypes = [
  {
    label: "Available",
    value: "available_slots",
    slug: "provider_available_schedules",
  },
  {
    label: "Already Booked",
    value: "booked_slots",
    slug: "booked_slots_schedules",
  },
  {
    label: "Unavailable",
    value: "unavailable_slots",
    slug: "unavailable_slots_schedules",
  },
];

export const allSlots = [
  "00:00",
  "00:15",
  "00:30",
  "00:45",
  "01:00",
  "01:15",
  "01:30",
  "01:45",
  "02:00",
  "02:15",
  "02:30",
  "02:45",
  "03:00",
  "03:15",
  "03:30",
  "03:45",
  "04:00",
  "04:15",
  "04:30",
  "04:45",
  "05:00",
  "05:15",
  "05:30",
  "05:45",
  "06:00",
  "06:15",
  "06:30",
  "06:45",
  "07:00",
  "07:15",
  "07:30",
  "07:45",
  "08:00",
  "08:15",
  "08:30",
  "08:45",
  "09:00",
  "09:15",
  "09:30",
  "09:45",
  "10:00",
  "10:15",
  "10:30",
  "10:45",
  "11:00",
  "11:15",
  "11:30",
  "11:45",
  "12:00",
  "12:15",
  "12:30",
  "12:45",
  "13:00",
  "13:15",
  "13:30",
  "13:45",
  "14:00",
  "14:15",
  "14:30",
  "14:45",
  "15:00",
  "15:15",
  "15:30",
  "15:45",
  "16:00",
  "16:15",
  "16:30",
  "16:45",
  "17:00",
  "17:15",
  "17:30",
  "17:45",
  "18:00",
  "18:15",
  "18:30",
  "18:45",
  "19:00",
  "19:15",
  "19:30",
  "19:45",
  "20:00",
  "20:15",
  "20:30",
  "20:45",
  "21:00",
  "21:15",
  "21:30",
  "21:45",
  "22:00",
  "22:15",
  "22:30",
  "22:45",
  "23:00",
  "23:15",
  "23:30",
  "23:45",
];

export const nightSlots = [
  "00:00",
  "00:15",
  "00:30",
  "00:45",
  "01:00",
  "01:15",
  "01:30",
  "01:45",
  "02:00",
  "02:15",
  "02:30",
  "02:45",
  "03:00",
  "03:15",
  "03:30",
  "03:45",
  "04:00",
  "04:15",
  "04:30",
  "04:45",
  "05:00",
  "05:15",
  "05:30",
  "05:45",
  "06:00",
  "06:15",
  "06:30",
  "06:45",
  "07:00",
  "07:15",
  "07:30",
  "07:45",
];

export const morningSlots = [
  "08:00",
  "08:15",
  "08:30",
  "08:45",
  "09:00",
  "09:15",
  "09:30",
  "09:45",
  "10:00",
  "10:15",
  "10:30",
  "10:45",
  "11:00",
  "11:15",
  "11:30",
  "11:45",
];

export const afternoonSlots = [
  "12:00",
  "12:15",
  "12:30",
  "12:45",
  "13:00",
  "13:15",
  "13:30",
  "13:45",
  "14:00",
  "14:15",
  "14:30",
  "14:45",
  "15:00",
  "15:15",
  "15:30",
  "15:45",
  "16:00",
  "16:15",
  "16:30",
  "16:45",
];

export const eveningSlots = [
  "17:00",
  "17:15",
  "17:30",
  "17:45",
  "18:00",
  "18:15",
  "18:30",
  "18:45",
  "19:00",
  "19:15",
  "19:30",
  "19:45",
  "20:00",
  "20:15",
  "20:30",
  "20:45",
  "21:00",
  "21:15",
  "21:30",
  "21:45",
  "22:00",
  "22:15",
  "22:30",
  "22:45",
  "23:00",
  "23:15",
  "23:30",
  "23:45",
];

export const durationSections = [
  {
    icon: <FiMoon fontSize={"1rem"} strokeWidth={2.5} color={ACCENT_800} />,
    title: "Night",
    value: "night",
    duration: "12:00AM - 07:45AM",
    slots: nightSlots,
    index: 0,
  },
  {
    icon: <FiSunrise fontSize={"1rem"} strokeWidth={2.5} color={ACCENT_800} />,
    title: "Morning",
    value: "morning",
    duration: "08:00AM - 11:45AM",
    slots: morningSlots,
    index: 1,
  },
  {
    icon: <FiSun fontSize={"1rem"} strokeWidth={2.5} color={ACCENT_800} />,
    title: "Afternoon",
    value: "afternoon",
    duration: "12:00PM - 04:45PM",
    slots: afternoonSlots,
    index: 2,
  },
  {
    icon: <FiSunset fontSize={"1rem"} strokeWidth={2.5} color={ACCENT_800} />,
    title: "Evening",
    value: "evening",
    duration: "05:00PM - 11:45PM",
    slots: eveningSlots,
    index: 3,
  },
];

export const amahaProviderReasons = [
  {
    label: "Nothing selected",
    value: "nothing_selected",
  },
  {
    label: "Unwell",
    value: "unwell",
  },
  {
    label: "MDT",
    value: "mdt",
  },
  {
    label: "Supervision",
    value: "supervision_session",
  },
  {
    label: "Training",
    value: "training",
  },
  {
    label: "Onsite Session",
    value: "onsite_session",
  },
  {
    label: "Webinar",
    value: "webinar",
  },
  {
    label: "Other",
    value: "other",
  },
];

export const childrenFirstProviderReasons = [
  {
    label: "Nothing selected",
    value: "nothing_selected",
  },
  {
    label: "Supervision",
    value: "supervision_session",
  },
  {
    label: "MH Adda",
    value: "mh_adda",
  },
  {
    label: "NDH Adda",
    value: "ndh_adda",
  },
  {
    label: "Lunch",
    value: "lunch",
  },
  {
    label: "Leave",
    value: "leave",
  },
  {
    label: "Unwell",
    value: "unwell",
  },
  {
    label: "Meeting",
    value: "meeting",
  },
  {
    label: "Observation",
    value: "observation",
  },
  {
    label: "Training",
    value: "training",
  },
  {
    label: "No Room Slot",
    value: "no_room_slot",
  },
  {
    label: "Report Writing",
    value: "report_writing",
  },
  {
    label: "Other",
    value: "other",
  },
];
